import { RoleDto, RolesApi } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useQuery, UseQueryResult } from 'react-query';

const QUERY_KEY = 'built-in-roles';

export const useGetBuiltInRoles = (
  builtInRolesApi: RolesApi,
  onError: (err: ErrorResponse) => void,
): UseQueryResult<RoleDto[]> =>
  useQuery([QUERY_KEY], async () => builtInRolesApi.getRoles().then((res) => res.data), {
    keepPreviousData: true,
    retry: false,
    onError,
  });
